<p-confirmPopup></p-confirmPopup>
<custom-table [config]="customTable" [rowExpansionTemplate]="tableRowexpansion">
</custom-table>

<ng-template #tableRowexpansion let-data>
    <app-pqrds-configuracion-actividades-by-tipo [tipoId]="data.id"
        [plazo]="data.plazo"  class="app-card  mx-auto border-1 border-top-none border-noround-top"/>
</ng-template>

<section>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">

        <p-dialog [(visible)]="displayModal" [modal]="true" [autoZIndex]="true" [draggable]="false" [resizable]="true"
            [maximizable]="true" [breakpoints]="{'640px': '100vw'}" [style]="{width: '80vw'}">

            <ng-template pTemplate="header">
                <CustomTitle [title]="formTitle" />
            </ng-template>

            <ng-template pTemplate="content">
                <main class="grid formgrid p-fluid">
                    <div class="field col-12 md:col-6">
                        <label for="nombre" class="ml-3">{{trans.nombre}}<span style="color: red">*</span></label>
                        <input pInputText formControlName="nombre" id="nombre" type="text" maxlength="100" />
                        <ng-container *ngIf="form.get('nombre')?.invalid && form.get('nombre')?.touched">
                            <app-form-group-error-message [control]="form.get('nombre')"></app-form-group-error-message>
                        </ng-container>
                    </div>
                    <div class="field col-12 md:col-6">
                        <label for="descripcion" class="ml-3">{{trans.descripcion}}<span
                                style="color: red">*</span></label>
                        <input pInputText formControlName="descripcion" id="descripcion" type="text" maxlength="255" />
                        <ng-container *ngIf="form.get('descripcion')?.invalid && form.get('descripcion')?.touched">
                            <app-form-group-error-message
                                [control]="form.get('descripcion')"></app-form-group-error-message>
                        </ng-container>
                    </div>
                    <div class="field col-12 md:col-6">
                        <label for="plazo" class="ml-3">{{trans.plazo}}<span style="color: red">*</span></label>
                        <p-inputNumber inputId="integeronly" formControlName="plazo" inputStyleClass="w-full"
                            styleClass="w-full" class="w-full">
                        </p-inputNumber>
                        <ng-container *ngIf="form.get('plazo')?.invalid && form.get('plazo')?.touched">
                            <app-form-group-error-message [control]="form.get('plazo')"></app-form-group-error-message>
                        </ng-container>
                    </div>
                    <div class="field col-12 md:col-6">
                        <label for="icono" class="ml-3">{{trans.icono}}<span style="color: red">*</span></label>
                        <p-dropdown [options]="iconos" formControlName="icono" optionLabel="name" optionValue="code"
                            [filter]="true" filterBy="name" appendTo="body" styleClass="w-full">
                        </p-dropdown>
                        <ng-container *ngIf="form.get('icono')?.invalid && form.get('icono')?.touched">
                            <app-form-group-error-message [control]="form.get('icono')"></app-form-group-error-message>
                        </ng-container>
                    </div>
                    <div class="field col-12 md:col-6 container-checkbox">
                        <div class="flex align-items-center gap-2">
                            <label for="requiereDocumentoRespuesta" class="label-text block ml-3">{{trans.requiereDocumentoRespuesta}}</label>
                        </div>
                        <p-checkbox [binary]="true" formControlName="requiereDocumentoRespuesta" inputId="binary"></p-checkbox>
                    </div>
                    <div class="field col-12 md:col-6 container-checkbox">
                        <div class="flex align-items-center gap-2">
                            <label for="asignacionManual" class="label-text block ml-3">{{trans.asignacionManual}}</label>
                        </div>
                        <p-checkbox [binary]="true" formControlName="asignacionManual" inputId="binary"></p-checkbox>
                    </div>
                </main>
            </ng-template>

            <ng-template pTemplate="footer">
                <div class="field col-12">
                    <div class="flex justify-content-between">
                        <button pButton type="button" [label]="trans.limpiar" iconPos="right" icon="pi pi-eraser"
                            class="tax-app-button" style="width: 16rem;" (click)="resetForm()"></button>
                        <button pButton type="submit" [label]="trans.guardar" icon="pi pi-save" iconPos="right"
                            class="tax-app-button" style="width: 16rem;"
                            [disabled]="!ls.hasRole(role.ADMIN_PQRSD)"></button>
                    </div>
                </div>
            </ng-template>
        </p-dialog>

    </form>
</section>

<custom-alert />
<app-pqrsd-tipos-historial></app-pqrsd-tipos-historial>
